import { Component, Input } from '@angular/core';
import { PayeeButtonComponent } from '../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-google-sso-button',
  templateUrl: './google-sso-button.component.html',
  styleUrls: ['./google-sso-button.component.scss'],
  imports: [PayeeButtonComponent, TranslateModule],
})
export class GoogleSsoButtonComponent {
  @Input({ required: true }) ssoUrl!: string;
}
